import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor'

import "./MouseGame.scss"

import dataJSON from "../../api/data.json"
import GameNode from "./GameNode"

class MouseGame extends Component {
  constructor() {
    super();
    this.state = {
      nextItem: 0,
      busy: false
    }
    this._dataLayer = this._dataLayer.bind(this);
    this.nextItemIs = this.nextItemIs.bind(this);
  }
  nextItemIs(item) {
    this.setState({
      nextItem: (item > dataJSON.game.length - 1 ? 0 : item)
    })
  }
  gameNodes() {
    return dataJSON.game.map((item, index) => <GameNode
      gameNode={item}
      key={index}
      index={index}
      _dataLayer={this._dataLayer}
      goToItem={this.state.nextItem}
      nextItemIs={this.nextItemIs}
    />
    );
  }
  _dataLayer(className) {
    console.log(className);
    if (!this.state.busy) {
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'Vaseline',
        'Action': 'Connect_the_Dots',
        'Label': className
      });
      this.setState({
        busy: true
      });
      window.setTimeout(() => {
        this.setState({
          busy: false
        });
      }, 500);
    }
  }
  render() {
    return (
      <section className="section section-mousegame">
        <ScrollableAnchor id={`section2`}>
          <div className="container">
            <div className="gamecontainer">
              {this.gameNodes()}
            </div>
          </div>
        </ScrollableAnchor>
      </section>
    );
  }
}

export default MouseGame;



// WEBPACK FOOTER //
// ./src/Components/MouseGame/MouseGame.js